import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { BSAReportingPage } from 'commons/types/DTO/bank/bsa'
import { Request } from 'commons/utils/request'
import { CircularProgress, FeedbackWidget } from 'ui/components'
import { Hr } from 'ui/components/Hr'
import { Page } from 'ui/components/Page'

import { PageButton } from './components'

import * as SC from './styles'

const Overview = () => {
  const { data } = useQuery<BSAReportingPage>({
    queryKey: ['bsa-reporting'],
    queryFn: () => Request.get(Request.urls.bank.bsaReportingPage),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })

  if (!data) {
    return <CircularProgress centered />
  }

  const { showCTRList, showSARList, showCTRBatchList, showSARBatchList, showParsedTransactionsList } = data

  return (
    <Page title="BSA Reporting">
      <Hr />
      <SC.Buttons>
        {showCTRList && <PageButton text="CTRs List" to="/bsa/ctrs" />}
        {showSARList && <PageButton text="SARs List" to="/bsa/sars" />}
        {showCTRBatchList && <PageButton text="CTR Batch List" to="/bsa/ctr-batch-list" />}
        {showSARBatchList && <PageButton text="SAR Batch List" to="/bsa/sar-batch-list" />}
        {showParsedTransactionsList && <PageButton text="Parsed Cash Transactions" to="/bsa/pct-list" />}
      </SC.Buttons>
      <FeedbackWidget contentPage="BSA Reporting" />
    </Page>
  )
}

export default Overview
